import { Button } from '@alifd/next';
import { message } from 'antd';
import { baseUrl } from '../utils';
const React = window.React;
const { createElement, useEffect, useRef, useState } = React;
const logicParamListUrl = `${baseUrl}/modules/print/printFormManage/logicDesignParamList`;
const PrintButton = (props) => {
    const { text, printId, ...otherProps } = props;
    useEffect(() => {
        console.log('printId', printId);
    }, [printId]);
    const getPrintParamList = (data) => {
        const paramItemList = {};
        const filterData = data.filter(item => +item.customType === 3 || +item.customType === 4);
        window.generateStructureForm && window.generateStructureForm();
        window.screenParamItemList && Object.keys(window.screenParamItemList).forEach(key => {
            const paramItem = filterData.find(item => item.paramName === key);
            if (paramItem) {
                paramItemList[key] = window.screenParamItemList[key];
            }
        });
        return paramItemList;
    };
    const handleClick = async () => {
        if (!printId) {
            message.warning('请先设置打印配置');
            return;
        }
        try {
            const res = await fetch(`${logicParamListUrl}?printFormId=${printId}`, {
                headers: {
                    Authorization: `Bearer ${window.token || localStorage.getItem('token')}`,
                },
            });
            let paramItemList = {};
            const data = await res.json();
            if (data && data.length) {
                paramItemList = getPrintParamList(data);
            }
            window.parent && window.parent.printById &&
                (window.parent.printById(printId, { paramItemList }));
        }
        catch (error) {
            console.error('请求出错:', error);
        }
    };
    return (createElement(Button, { ...otherProps, onClick: handleClick }, text));
};
export default PrintButton;
